import { UploadRejectionCode, UploadStatus } from '../enum';
import { RejectedUpload, UploadError, UploadType } from '../models';

export const isRejectedUpload = (
  upload: UploadType
): upload is RejectedUpload => upload.status === UploadStatus.REJECTED;

export const getUploadErrorMessage = (code: UploadRejectionCode): string => {
  switch (code) {
    case UploadRejectionCode.FILE_TOO_LARGE:
      return 'File size too large';
    case UploadRejectionCode.UNKNOWN:
    default:
      return 'Failed to upload';
  }
};

export const convertByteToMb = (bytes: number) =>
  Number((bytes / (1024 * 1024)).toFixed());

export const fileSizeValidator = (
  file: File,
  uploadFileSizeMbLimit: number
): UploadError | null =>
  convertByteToMb(file.size) > uploadFileSizeMbLimit
    ? {
        code: UploadRejectionCode.FILE_TOO_LARGE,
        message: getUploadErrorMessage(UploadRejectionCode.FILE_TOO_LARGE),
      }
    : null;
